var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiplyCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM10.5858 9.17157C10.1952 8.78105 9.56206 8.78105 9.17154 9.17157C8.78101 9.5621 8.78101 10.1953 9.17154 10.5858L10.5858 12L9.17154 13.4142C8.78101 13.8047 8.78101 14.4379 9.17154 14.8284C9.56206 15.219 10.1952 15.219 10.5858 14.8284L12 13.4142L13.4142 14.8284C13.8047 15.219 14.4379 15.219 14.8284 14.8284C15.2189 14.4379 15.2189 13.8047 14.8284 13.4142L13.4142 12L14.8284 10.5858C15.2189 10.1953 15.2189 9.5621 14.8284 9.17157C14.4379 8.78105 13.8047 8.78105 13.4142 9.17157L12 10.5858L10.5858 9.17157Z",
    fill: "#E26E6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplyCircle);
export default __webpack_public_path__ + "static/media/multiply-circle.91b17b230ceee536687bef1ad790d3a7.svg";
export { ForwardRef as ReactComponent };